import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { StyledStepProgessBar } from './index.style';

const StepProgressBar = ({
  amountStep = 3,
  activeStep,
  onPrevious,
  hasButtonPreviousDisabled,
  onSkip,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <StyledStepProgessBar isMobile={isMobile}>
      {isMobile && (
        <ArrowBackRoundedIcon
          onClick={() => {
            if (hasButtonPreviousDisabled) return;
            onPrevious();
          }}
          className={hasButtonPreviousDisabled && 'disabled-prev-btn'}
        />
      )}
      <div className="container-step">
        {[...Array(amountStep).keys()].map((step) => (
          <div
            key={step}
            className={`step ${activeStep === step && 'active-step'}`}
          />
        ))}
      </div>
      {isMobile && (
        <div
          role="button"
          onClick={onSkip}
          tabIndex="0"
          className="skip-action"
        >
          {t('skip')}
        </div>
      )}
    </StyledStepProgessBar>
  );
};

export default StepProgressBar;
